/* eslint-disable react/jsx-sort-props */
// @flow

import React, {useEffect, useState} from 'react';
import { useStore } from '../../store';
import moment from 'moment';
import { log } from '../../utils/jsUtils';
import SPBackend from '../../services/SPBackend';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Input from '@mui/material/Input';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import withStyles from '../../utils/withStyles';
import styles from './Styles/SimpleMsgDialog.Style';

type Props = {
  dialogTitle: Object,
  dialogContent: Object,
  dialogActions: Object,
  open: Boolean,
  classes: Object
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up"
ref={ref}
{...props}
         />;
});

// eslint-disable-next-line react/no-multi-comp
const SimpleMsgDialog = (props: Props) => {
  const {
    classes,
    dialogTitle,
    dialogContent,
    dialogActions,
    open
  } = props;

  return (
      <Dialog
        aria-labelledby='form-assign-task'
        BackdropProps={{
          classes: {
            root: classes.backdrop
          }
        }}
        classes={{
          paper: classes.dialogRoot
        }}
        open={open}
        TransitionComponent={Transition}
      >
        <DialogTitle
         className={classes.title}
        >{dialogTitle}</DialogTitle>
        
          <DialogContent
            className={classes.content}
          >
            {dialogContent}
          </DialogContent>
          {
            dialogActions
            ? <DialogActions
                className={classes.actions}
              >
                {dialogActions}
              </DialogActions>
            : null
          }
          
      </Dialog>
  );
};

export default withStyles(styles)(SimpleMsgDialog);
